(function () {
    // This code is for accordion Component
    const accordionItems = document.querySelectorAll(".accordion__item");

    accordionItems.forEach((item) => {
        const button = item.querySelector(".accordion__button");
        const content = item.querySelector(".accordion__content");

        button.addEventListener("click", function () {
            const expanded = button.getAttribute("aria-expanded") === "true" || false;

            accordionItems.forEach((item) => {
                item.querySelector(".accordion__button").setAttribute("aria-expanded", false);
                item.querySelector(".accordion__content").setAttribute("aria-hidden", true);
            });

            button.setAttribute("aria-expanded", !expanded);
            content.setAttribute("aria-hidden", expanded);

            button.scrollIntoView({ behavior: "smooth", block: "nearest" });
        });
    });

    // This Code is for Accordion used in Nav
    const buttons = document.querySelectorAll("[data-accordion]");
    const toggleButton = (button, target, hide) => {
        if (typeof hide === "undefined") {
            hide = button.getAttribute("aria-expanded") === "true" || false;
        }
        button.setAttribute("aria-expanded", !hide);
        // button.innerText = !hide ? button.getAttribute("data-label-expanded") || button.innerText : button.getAttribute("data-label") || button.innerText
        if (button.getAttribute("data-label") && button.getAttribute("data-label-expanded")) {
            button.innerText = !hide ? button.getAttribute("data-label-expanded") || button.innerText : button.getAttribute("data-label") || button.innerText;
        }
        if (button.getAttribute("data-accordion-button") === "alternate") {
            target.setAttribute("data-expanded", !hide);
        } else {
            target.hidden = hide;
            // enable to auto-scroll to opened accordions
            // target.scrollIntoView({ behavior: "smooth" })
        }
    };

    const getTarget = (button) => {
        const identifier = button.getAttribute("aria-controls") || button.id;
        return document.querySelector(`[aria-labelledby="${identifier}"]`);
    };

    buttons.forEach((button) => {
        let target = getTarget(button);
        button.addEventListener("click", (event) => {
            event.preventDefault();

            if (button.getAttribute("data-accordion-set")) {
                const set = button.getAttribute("data-accordion-set");
                buttons.forEach((other) => {
                    if (other.getAttribute("data-accordion-set") === set) {
                        target = getTarget(other);
                        if (button !== other) {
                            toggleButton(other, target, true);
                        } else {
                            toggleButton(button, target);
                        }
                    }
                });
            } else if (button.getAttribute("data-accordion-unique") !== "false") {
                buttons.forEach((other) => {
                    target = getTarget(other);
                    if (button !== other) {
                        toggleButton(other, target, true);
                    } else {
                        toggleButton(button, target);
                    }
                });
            } else {
                toggleButton(button, target);
            }
        });
    });
})();
